










































import { Component, Vue } from 'vue-property-decorator'
import { NotificationsState } from '@/store/notifications/interfaces'
import NotificationsListItem from './notifications-list-item/notifications-list-item.vue'
import NotificationsListEmpty from './notifications-list-state/states/notifications-list-empty/notifications-list-empty.vue'
import NotificationsListServerError from './notifications-list-state/states/notifications-list-server-error/notifications-list-server-error.vue'
import NotificationsListLoading from '@/components/notifications-hub-content/notifications-list/notifications-list-state/states/notifications-list-loading/notifications-list-loading.vue'
import NotificationsListLoadMore from '@/components/notifications-hub-content/notifications-list/notifications-list-load-more/notifications-list-load-more.vue'
import store, { currentState } from '@/store'
import { initialNotificationsState } from '@/services/utils'

@Component({
  name: 'notifications-list',
  components: {
    NotificationsListLoading,
    NotificationsListItem,
    NotificationsListEmpty,
    NotificationsListServerError,
    NotificationsListLoadMore,
  },
})
export default class NotificationsListComponent extends Vue {
  private unsubscribe: any | null = null
  state: NotificationsState = initialNotificationsState

  mounted(): void {
    this.state = currentState.notifications
    this.unsubscribe = store.subscribe(() => (this.state = store.getState().notifications))
  }

  beforeDestroy(): void {
    this.unsubscribe()
  }
}
